import React from 'react';
import PropTypes from 'prop-types';
import ReactGA from 'react-ga';
import classnames from 'classnames';

import AddVoiceGreeting from './AddVoiceGreeting';

import WellnessMandatory from './Wellness/Mandatory';
import WellnessBusinessProfile from './Wellness/BusinessProfile';
import WellnessNotifications from './Wellness/Notifications';
import WellnessBookings from './Wellness/Bookings';
import WellnessChats from './Wellness/Chats';
import WellnessClientBilling from './Wellness/ClientBilling';
import WellnessAdvanced from './Wellness/Advanced';
import Actions from './saveButtonWellness';

import DentalNotifications from './Dental/Notifications';
import DentalBookings from './Dental/Bookings';
import DentalChats from './Dental/Chats';
import DentalClientBilling from './Dental/ClientBilling';
import DentalBusinessProfile from './Dental/BusinessProfile';
import HiddenPreferences from './Wellness/HiddenPreferences';

import FitnessClasses from './Fitness/Classes';
import FitnessMemberships from './Fitness/Memberships';
import FitnessChats from './Fitness/Chats';

import StatusModal from './StatusModal';
import Footnote from './../Footnote';

import Loading from '../common/Loading';

import { DENTAL, FITNESS } from './../../assets/Domains';

import utils from './../../lib/utils';

import './index.scss';
import { getBusinessDetails } from '../../actions/business';

const encodeData = (original, updated) => {
  const encoded = {
    ...original,
    website_link: updated.website_link,
    faqs_link: updated.faqs_link,
    address_details: updated.address_details,
    business_contact_numbers: updated.business_contact_numbers,
    billing_contact_details: updated.billing_contact_details,
    business_open_days: updated.business_open_days,
    business_working_hours: updated.business_working_hours,
    notification_mode: original.notification_mode,
    notification_email: original.notification_email,
    notification_phone: original.notification_phone,

    client_notification_preferences: {
      ...original.preferences.client_notification_preferences,
      ...updated.client_notification_preferences,
      notification_channels: updated.notification_mode,
      notification_emails: updated.notification_email,
      notification_phones: updated.notification_phone,
      receive_immediately: updated.receive_immediately,
      is_notify_staff_for_same_day_events:
        updated.is_notify_staff_for_same_day_events,
    },

    allow_mindbody_welcome_email: updated.allow_mindbody_welcome_email,
    allow_mindbody_appointment_email: updated.allow_mindbody_appointment_email,
    first_message: updated.first_message,
    client_outside_door: updated.client_outside_door,
    post_booking_instructions: updated.post_booking_instructions,
    pricing_info: updated.pricing_info,
    hold_customer_membership_info: updated.hold_customer_membership_info,
    membership_cancellation_policy: updated.membership_cancellation_policy,
    custom_requests: updated.custom_requests,
    showers_available: updated.showers_available,
    changing_rooms_available: updated.changing_rooms_available,
    dress_code_for_classes: updated.dress_code_for_classes,

    appointment_preferences: {
      ...original.preferences.appointment_preferences,
      ...updated.appointment_preferences,
      client_running_late: updated.client_running_late,
      min_time_to_booking: updated.min_time_to_booking,
      reschedule_duration: updated.reschedule_duration,
      disable_meevo_reschedule: updated.disable_meevo_reschedule,
      reschedule_appt_within_duration: updated.reschedule_appt_within_duration,
      reschedule_charges: updated.reschedule_charges,
      cancel_appt_within_duration: updated.cancel_appt_within_duration,
      cancellation_duration: updated.cancellation_duration,
      cancellation_charges: updated.cancellation_charges,
      cancellation_policy_url: updated.cancellation_policy_url,
      collect_credit_card: updated.collect_credit_card,
      cc_not_on_file_action: updated.cc_not_on_file_action,
      discount_coupons: updated.discount_coupons,
      collect_coupon_number: updated.collect_coupon_number,
      cc_for_coupons: updated.cc_for_coupons,
      accepted_insurance_policies: updated.accepted_insurance_policies,
      is_expired_voucher_accepted: updated.is_expired_voucher_accepted,
      can_voucher_be_combined_with_offer:
        updated.can_voucher_be_combined_with_offer,
      can_share_pricing_with_clients: updated.can_share_pricing_with_clients,
      appointments_walk_in: updated.appointments_walk_in,
      is_walk_in_on_availability: updated.is_walk_in_on_availability,
      average_booking_value: updated.average_booking_value,
      can_reschedule_booking_online: updated.can_reschedule_booking_online,
      can_cancel_booking_online: updated.can_cancel_booking_online,
      online_booking_link: updated.online_booking_link,
      collect_cc_before_booking: updated.collect_cc_before_booking,
      cc_wait_time_to_booking: updated.cc_wait_time_to_booking,
      show_zero_duration_appointment_segments: updated.show_zero_duration_appointment_segments,
      hide_service_times: updated.hide_service_times,
      staff_schedule_span: updated.staff_schedule_span,
    },

    classes_preferences: {
      ...original.preferences.classes_preferences,
      customer_limitations_info: updated.customer_limitations_info,
      guest_policy_info: updated.guest_policy_info,
      multiple_customer_bookings_info: updated.multiple_customer_bookings_info,
      private_appointments_info: updated.private_appointments_info,
      free_pricing_plan_name: updated.free_pricing_plan_name,
      client_running_late: updated.client_running_late,
      classes_payment_info: updated.classes_payment_info,
      discount_coupons: updated.discount_coupons,
      can_book_private_appointment: updated.can_book_private_appointment,
      cancellation_policy: updated.cancellation_policy,
      beginner_class_info: updated.beginner_class_info,
      new_customer_promotion_info: updated.new_customer_promotion_info,
      trial_classes_info: updated.trial_classes_info,
      can_update_client_attendance: updated.can_update_client_attendance,
      min_time_to_cancellation: updated.min_time_to_cancellation,
      min_time_to_booking: updated.min_time_to_booking_classes,
      classes_walk_in: updated.classes_walk_in,
      classes_suggestion: updated.classes_suggestion,
      allow_unpaid_bookings: updated.allow_unpaid_bookings,
    },
    cancellation_details: updated.cancellation_details || original.cancellation_details,
    can_auto_cancel_if_user_inactive: updated.can_auto_cancel_if_user_inactive,
    customGreetingFName: updated.customGreetingFName,
    custom_post_booking_instructions: (() => {
      const value = updated.custom_post_booking_instructions;
      if (typeof value === 'string') {
        if (!value || value.trim() === '') {
          return null;
        }
        try {
          return JSON.parse(value);
        } catch {
          return value;
        }
      }
      return value;
    })(),
    pre_workflow_type: updated.pre_workflow_type,
    promotional_add_client: updated.promotional_add_client,
    send_le_status_bn: updated.send_le_status_bn,
    send_staff_info: updated.send_staff_info,
    preferred_location: updated.preferred_location,
    request_forwarded_message: updated.request_forwarded_message,
    notes: updated.notes,
    slot_size: updated.slot_size,
    slot_interval: updated.slot_interval,
    user_login_link: updated.user_login_link,
    is_multi_location: updated.is_multi_location,
    is_onboarded_as_multi: updated.is_onboarded_as_multi,
    staff_preference_honoured: updated.staff_preference_honoured,
    extra_secure_appointment_strings: updated.extra_secure_appointment_strings,
    send_staff_first_name: updated.send_staff_first_name,
    block_booking_sw_calls: updated.block_booking_sw_calls,
    block_auto_proposal: updated.block_auto_proposal,
    enable_speech_hint: updated.enable_speech_hint,
    email_add_client: updated.email_add_client,
    sms_add_client: updated.sms_add_client,
    lead_engage_follow_up_time: updated.lead_engage_follow_up_time,
    cancel_and_book: updated.cancel_and_book,
    staging: updated.staging,
    blocked_words_in_message: updated.blocked_words_in_message,
    staff_location_preferences: (() => {
      const value = updated.staff_location_preferences;
      if (typeof value === 'string') {
        if (!value || value.trim() === '') {
          return null;
        }
        try {
          return JSON.parse(value);
        } catch {
          return value;
        }
      }
      return value;
    })(),
    location_workflow_preferences: (() => {
      const value = updated.location_workflow_preferences;
      if (typeof value === 'string') {
        if (!value || value.trim() === '') {
          return null;
        }
        try {
          return JSON.parse(value);
        } catch {
          return value;
        }
      }
      return value;
    })(),
    blocked_staff: updated.blocked_staff,
    blocked_service: updated.blocked_service,
    blocked_location: updated.blocked_location,
    blocked_resources: updated.blocked_resources,
    resource_start_times: updated.resource_start_times,
    vm_time_out: updated.vm_time_out,
  };
  return encoded;
};

const decodeData = (data) => {
  const preferences = Object.assign({}, data.preferences);
  const client_notification_preferences = Object.assign(
    {},
    data.client_notification_preferences,
  );
  if (!preferences.appointment_preferences)
    preferences.appointment_preferences = {};
  if (!preferences.classes_preferences) preferences.classes_preferences = {};

  return {
    website_link: preferences.website_link,
    faqs_link: preferences.faqs_link,
    address_details: preferences.address_details,
    business_contact_numbers: preferences.business_contact_numbers,
    billing_contact_details: preferences.billing_contact_details,
    business_open_days: preferences.business_open_days,
    business_working_hours: preferences.business_working_hours,
    notification_mode: client_notification_preferences.notification_channels,
    notification_email: client_notification_preferences.notification_emails,
    notification_phone: client_notification_preferences.notification_phones,
    receive_immediately: client_notification_preferences.receive_immediately,
    is_notify_staff_for_same_day_events:
      client_notification_preferences.is_notify_staff_for_same_day_events,
    allow_mindbody_welcome_email: preferences.allow_mindbody_welcome_email,
    allow_mindbody_appointment_email:
      preferences.allow_mindbody_appointment_email,
    first_message: preferences.first_message,
    client_outside_door: preferences.client_outside_door,
    showers_available: preferences.showers_available,
    changing_rooms_available: preferences.changing_rooms_available,
    dress_code_for_classes: preferences.dress_code_for_classes,
    post_booking_instructions: preferences.post_booking_instructions,
    hold_customer_membership_info: preferences.hold_customer_membership_info,
    membership_cancellation_policy: preferences.membership_cancellation_policy,
    custom_requests: preferences.custom_requests,

    client_running_late:
      preferences.appointment_preferences.client_running_late,
    min_time_to_booking:
      preferences.appointment_preferences.min_time_to_booking,
    disable_meevo_reschedule:
      preferences.appointment_preferences.disable_meevo_reschedule,
    reschedule_duration:
      preferences.appointment_preferences.reschedule_duration,
    reschedule_appt_within_duration:
      preferences.appointment_preferences.reschedule_appt_within_duration,
    reschedule_charges: preferences.appointment_preferences.reschedule_charges,
    cancel_appt_within_duration:
      preferences.appointment_preferences.cancel_appt_within_duration,
    cancellation_duration:
      preferences.appointment_preferences.cancellation_duration,
    cancellation_charges:
      preferences.appointment_preferences.cancellation_charges,
    cancellation_policy_url:
      preferences.appointment_preferences.cancellation_policy_url,
    collect_credit_card:
      preferences.appointment_preferences.collect_credit_card,
    collect_cc_before_booking:
      preferences.appointment_preferences.collect_cc_before_booking,
    cc_not_on_file_action:
      preferences.appointment_preferences.cc_not_on_file_action,
    discount_coupons: preferences.appointment_preferences.discount_coupons,
    collect_coupon_number:
      preferences.appointment_preferences.collect_coupon_number,
    cc_for_coupons: preferences.appointment_preferences.cc_for_coupons,
    accepted_insurance_policies:
      preferences.appointment_preferences.accepted_insurance_policies,
    is_expired_voucher_accepted:
      preferences.appointment_preferences.is_expired_voucher_accepted,
    can_voucher_be_combined_with_offer:
      preferences.appointment_preferences.can_voucher_be_combined_with_offer,
    can_share_pricing_with_clients:
      preferences.appointment_preferences.can_share_pricing_with_clients,
    pricing_info: preferences.pricing_info,
    appointments_walk_in:
      preferences.appointment_preferences.appointments_walk_in,
    is_walk_in_on_availability:
      preferences.appointment_preferences?.is_walk_in_on_availability,
    average_booking_value:
      preferences.appointment_preferences?.average_booking_value,
    can_reschedule_booking_online:
      preferences.appointment_preferences?.can_reschedule_booking_online,
    can_cancel_booking_online:
      preferences.appointment_preferences?.can_cancel_booking_online,
    online_booking_link:
      preferences.appointment_preferences?.online_booking_link,

    customer_limitations_info:
      preferences.classes_preferences.customer_limitations_info,
    guest_policy_info: preferences.classes_preferences.guest_policy_info,
    multiple_customer_bookings_info:
      preferences.classes_preferences.multiple_customer_bookings_info,
    private_appointments_info:
      preferences.classes_preferences.private_appointments_info,
    free_pricing_plan_name:
      preferences.classes_preferences.free_pricing_plan_name,
    classes_payment_info: preferences.classes_preferences.classes_payment_info,
    can_book_private_appointment:
      preferences.classes_preferences.can_book_private_appointment,
    cancellation_policy: preferences.classes_preferences.cancellation_policy,
    beginner_class_info: preferences.classes_preferences.beginner_class_info,
    new_customer_promotion_info:
      preferences.classes_preferences.new_customer_promotion_info,
    trial_classes_info: preferences.classes_preferences.trial_classes_info,
    can_update_client_attendance:
      preferences.classes_preferences.can_update_client_attendance,
    min_time_to_cancellation:
      preferences.classes_preferences.min_time_to_cancellation,
    min_time_to_booking_classes:
      preferences.classes_preferences.min_time_to_booking,
    classes_walk_in: preferences.classes_preferences.classes_walk_in,
    classes_suggestion: preferences.classes_preferences.classes_suggestion,
    appointment_preferences: preferences.appointment_preferences,
    cancellation_details: preferences.cancellation_details,
    client_notification_preferences: client_notification_preferences,
    can_auto_cancel_if_user_inactive:
      preferences.can_auto_cancel_if_user_inactive,
    customGreetingFName: preferences.customGreetingFName,
    custom_post_booking_instructions: (() => {
      const value = preferences.custom_post_booking_instructions;
      if (value === null || value === undefined) {
        return '';
      }
      if (typeof value === 'string') {
        return value;
      }
      if (typeof value === 'object') {
        try {
          return JSON.stringify(value, null, 2);
        } catch {
          return '';
        }
      }
      return String(value);
    })(),
    pre_workflow_type: preferences.pre_workflow_type,
    promotional_add_client: preferences.promotional_add_client,
    send_le_status_bn: preferences.send_le_status_bn,
    send_staff_info: preferences.send_staff_info,
    preferred_location: preferences.preferred_location,
    request_forwarded_message: preferences.request_forwarded_message,
    notes: preferences.notes,
    slot_size: preferences.slot_size,
    slot_interval: preferences.slot_interval,
    user_login_link: preferences.user_login_link,
    is_multi_location: preferences.is_multi_location,
    is_onboarded_as_multi: preferences.is_onboarded_as_multi,
    staff_preference_honoured: preferences.staff_preference_honoured,
    extra_secure_appointment_strings: preferences.extra_secure_appointment_strings,
    send_staff_first_name: preferences.send_staff_first_name,
    block_booking_sw_calls: preferences.block_booking_sw_calls,
    block_auto_proposal: preferences.block_auto_proposal,
    enable_speech_hint: preferences.enable_speech_hint,
    email_add_client: preferences.email_add_client,
    sms_add_client: preferences.sms_add_client,
    lead_engage_follow_up_time: preferences.lead_engage_follow_up_time,
    cancel_and_book: preferences.cancel_and_book,
    staging: preferences.staging,
    cc_wait_time_to_booking: preferences.appointment_preferences.cc_wait_time_to_booking,
    show_zero_duration_appointment_segments: preferences.appointment_preferences.show_zero_duration_appointment_segments,
    hide_service_times: preferences.appointment_preferences.hide_service_times,
    staff_schedule_span: preferences.appointment_preferences.staff_schedule_span,
    allow_unpaid_bookings: preferences.classes_preferences.allow_unpaid_bookings,
    blocked_words_in_message: preferences.blocked_words_in_message || [],
    staff_location_preferences: (() => {
      const value = preferences.staff_location_preferences;
      if (value === null || value === undefined) {
        return '';
      }
      if (typeof value === 'string') {
        return value;
      }
      if (typeof value === 'object') {
        try {
          return JSON.stringify(value, null, 2);
        } catch {
          return '';
        }
      }
      return String(value);
    })(),
    location_workflow_preferences: (() => {
      const value = preferences.location_workflow_preferences;
      if (value === null || value === undefined) {
        return '';
      }
      if (typeof value === 'string') {
        return value;
      }
      if (typeof value === 'object') {
        try {
          return JSON.stringify(value, null, 2);
        } catch {
          return '';
        }
      }
      return String(value);
    })(),
    blocked_staff: preferences.blocked_staff || [],
    blocked_service: preferences.blocked_service || [],
    blocked_location: preferences.blocked_location || [],
    blocked_resources: preferences.blocked_resources || [],
    resource_start_times: preferences.resource_start_times || [],
    vm_time_out: preferences.vm_time_out,
  };
};

const validate = (preferences, actionIndex, propPreference) => {
  const errors = {};

  if (
    preferences.website_link &&
    !utils.isValidURL(preferences.website_link) &&
    actionIndex === 0
  ) {
    errors.website_link = {
      message: 'Please enter a valid URL',
    };
  }
  if (
    preferences.online_booking_link &&
    !utils.isValidURL(preferences.online_booking_link) &&
    actionIndex === 3
  ) {
    errors.online_booking_link = {
      message: 'Please enter a valid URL',
    };
  }

  if (
    propPreference?.schema?.pricing_info &&
    !preferences.pricing_info &&
    actionIndex === 3 &&
    preferences.can_share_pricing_with_clients
  ) {
    errors.pricing_info = {
      message: 'Please enter pricing info',
    };
  } else if (
    propPreference?.schema?.pricing_info &&
    preferences.pricing_info.length &&
    !utils.isValidURL(preferences.pricing_info) &&
    actionIndex === 3 &&
    preferences.can_share_pricing_with_clients
  ) {
    errors.pricing_info = {
      message: 'Please enter valid pricing info',
    };
  }

  if (
    preferences.faqs_link &&
    !utils.isValidURL(preferences.faqs_link) &&
    actionIndex === 0
  ) {
    errors.faqs_link = {
      message: 'Please enter a valid URL',
    };
  }

  if (
    preferences.address_details &&
    preferences.address_details.length &&
    actionIndex === 0
  ) {
    preferences.address_details.map((info, index) => {
      if (info && !info.address.trim()) {
        errors[`address_details.${index}.address`] = {
          message: 'Please enter your address',
        };
      }

      return info;
    });
  }

  if (
    (!preferences.business_contact_numbers ||
      !preferences.business_contact_numbers.length ||
      !preferences.business_contact_numbers[0]) &&
    actionIndex === 0
  ) {
    errors['business_contact_numbers.0'] = {
      message: 'Please enter a phone number',
    };
  } else if (
    preferences.business_contact_numbers &&
    preferences.business_contact_numbers.length &&
    actionIndex === 0
  ) {
    preferences.business_contact_numbers.map((phone, index) => {
      if (phone && !utils.isValidPhone(phone)) {
        errors[`business_contact_numbers.${index}`] = {
          message: 'Please enter a valid phone number',
        };
      } else {
        delete errors[`business_contact_numbers.${index}`];
      }
      return phone;
    });
  }

  if (!preferences.billing_contact_details.name && actionIndex === 0) {
    errors['billing_contact_details.name'] = {
      message: 'Please enter contact name',
    };
  } else if (
    preferences.billing_contact_details &&
    !preferences.billing_contact_details.name.trim().length &&
    actionIndex === 0
  ) {
    errors['billing_contact_details.name'] = {
      message: 'Please enter valid contact name',
    };
  }

  if (!preferences.billing_contact_details.email && actionIndex === 0) {
    errors['billing_contact_details.email'] = {
      message: 'Please enter contact email',
    };
  } else if (
    !utils.isValidEmail(preferences.billing_contact_details.email) &&
    actionIndex === 0
  ) {
    errors['billing_contact_details.email'] = {
      message: 'Please enter a valid email',
    };
  }

  if (!preferences.billing_contact_details.phone_number && actionIndex === 0) {
    errors['billing_contact_details.phone_number'] = {
      message: 'Please enter contact phone',
    };
  } else if (
    preferences.billing_contact_details.phone_number &&
    !utils.isValidPhone(preferences.billing_contact_details.phone_number) &&
    actionIndex === 0
  ) {
    errors['billing_contact_details.phone_number'] = {
      message: 'Please enter a valid phone number',
    };
  }

  if (!preferences.first_message.trim() && actionIndex === 1) {
    errors.first_message = {
      message: 'Please enter a message',
    };
  }

  if (!preferences.notification_mode && actionIndex === 2) {
    errors.notification_mode = {
      message: 'Please select a notification mode',
    };
  }

  if (
    preferences.notification_mode.includes('EMAIL') &&
    !preferences.notification_email &&
    actionIndex === 2
  ) {
    errors.notification_email = {
      message: 'Please enter an email',
    };
  } else if (
    preferences.notification_mode.includes('EMAIL') &&
    !utils.isValidMultipleEmails(preferences.notification_email) &&
    actionIndex === 2
  ) {
    errors.notification_email = {
      message: 'Please enter a valid email',
    };
  }

  if (
    preferences.notification_mode.includes('SMS') &&
    !preferences.notification_phone &&
    actionIndex === 2
  ) {
    errors.notification_phone = {
      message: 'Please enter a phone number',
    };
  } else if (
    preferences.notification_mode.includes('SMS') &&
    !utils.isValidPhone(preferences.notification_phone) &&
    actionIndex === 2
  ) {
    errors.notification_phone = {
      message: 'Please enter a valid phone number',
    };
  }

  if (
    preferences.reschedule_charges &&
    !/^\$[0-9.]+|[0-9.]+%$/.test(preferences.reschedule_charges) &&
    actionIndex === 3
  ) {
    errors.reschedule_charges = {
      message: 'Invalid reschedule charge',
    };
  }

  if (
    preferences.cancellation_charges &&
    !/^\$[0-9.]+|[0-9.]+%$/.test(preferences.cancellation_charges) &&
    actionIndex === 3
  ) {
    errors.cancellation_charges = {
      message: 'Invalid cancellation charge',
    };
  }

  if (
    preferences.custom_post_booking_instructions &&
    typeof preferences.custom_post_booking_instructions === 'string'
  ) {
    const validateJSON = (value) => {
      if (!value || value.trim() === '') {
        return { isValid: true };
      }
      
      const trimmedValue = value.trim();
      
      if (!trimmedValue.startsWith('{') || !trimmedValue.endsWith('}')) {
        return { 
          isValid: false, 
          error: 'Must be a valid JSON object (e.g., {"key": "value"})' 
        };
      }
      
      try {
        const parsed = JSON.parse(trimmedValue);
        
        if (typeof parsed !== 'object' || parsed === null || Array.isArray(parsed)) {
          return { 
            isValid: false, 
            error: 'Must be a valid JSON object' 
          };
        }
        
        return { isValid: true };
      } catch (error) {
        return { 
          isValid: false, 
          error: 'Contains invalid JSON syntax' 
        };
      }
    };

    const jsonValidation = validateJSON(preferences.custom_post_booking_instructions);
    if (!jsonValidation.isValid) {
      errors.custom_post_booking_instructions = {
        message: jsonValidation.error,
      };
    }
  }

  return errors;
};

const isMandatoryComplete = () => {
  return true;
};

export default class Preferences extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      preferences: {
        address_details: [{}],
        billing_contact_details: {},
        custom_requests: {},
        allow_mindbody_appointment_email: true,
        allow_mindbody_welcome_email: true,
        appointment_preferences: {
          availability_type: 'SLOT_BASED',
        },
        cancellation_details: {
          CANCELLATION_TYPE: 'AfterBooking',
          HOURS_TO_CANCEL: '24',
        },
        client_notification_preferences: {
          always_notify: true,
          notification_frequency: 'INSTANTLY',
          recipient_type: 'OWNER',
          notifyBusinessBrand: 'BUSINESS_BRAND',
          recipient_name: '',
          subscribed_events: ['BOOKING_NOTIFICATION'],
        },
        can_auto_cancel_if_user_inactive: false,
        customGreetingFName: '',
        custom_post_booking_instructions: {},
        pre_workflow_type: 'PRE_BOOKING',
        promotional_add_client: true,
        send_le_status_bn: true,
        send_staff_info: false,
        preferred_location: '',
        request_forwarded_message: '',
        notes: '',
        slot_size: 'PT5M',
        slot_interval: null,
        user_login_link: '',
        is_multi_location: false,
        is_onboarded_as_multi: false,
        staff_preference_honoured: false,
        extra_secure_appointment_strings: false,
        send_staff_first_name: false,
        block_booking_sw_calls: false,
        block_auto_proposal: false,
        enable_speech_hint: false,
        email_add_client: false,
        sms_add_client: false,
        lead_engage_follow_up_time: '',
        cancel_and_book: false,
        staging: false,
        collect_cc_before_booking: false,
        cc_wait_time_to_booking: '',
        show_zero_duration_appointment_segments: false,
        hide_service_times: false,
        staff_schedule_span: '',
        allow_unpaid_bookings: false,
        blocked_words_in_message: [],
        staff_location_preferences: '',
        location_workflow_preferences: '',
        blocked_staff: [],
        blocked_service: [],
        blocked_location: [],
        blocked_resources: [],
        resource_start_times: [],
        vm_time_out: 'PT10M',
      },
      isMytime: utils.getCookie('booking_software') == 'MYTIME',
      bookingSW: utils.getCookie('booking_software'),
      errors: {},
      saveError: null,
      statusModalVisibility: false,
      isSaving: false,
      accordion: -1,
    };

    this.formRefs = {};

    this.onPreferencesFormSubmit = this.onPreferencesFormSubmit.bind(this);
    this.onVerifyStatusModalClose = this.onVerifyStatusModalClose.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.HandleNotificationSetting = this.HandleNotificationSetting.bind(this);
    this.handleInputBlur = this.handleInputBlur.bind(this);
    this.handleCustomPreferenceAdd = this.handleCustomPreferenceAdd.bind(this);
    this.setRef = this.setRef.bind(this);
    this.openAccordion = this.openAccordion.bind(this);
  }

  componentDidMount() {
    ReactGA.pageview(window.location.hash);
    ReactGA.event({
      category: 'User',
      action: 'Click on Preference Tab(Wellness)',
      label: 'Preference(Wellness)  Page',
    });
    const { auth } = this.props;
    const { studio_id } = auth;
    const bzid = this.props.business.id || studio_id;
    this.props.getFreePricingPlans();
    this.props.getPreferences();
    if (bzid) {
      this.props.getBusinessDetails(bzid);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      typeof nextProps.preferences.isPreferenceSaved === 'boolean' &&
      nextProps.preferences.isPreferenceSaved !==
        this.props.preferences.isPreferenceSaved &&
      nextProps.preferences.isPreferenceSaved
    ) {
      this.setState(
        {
          isSaving: false,
          saveError: null,
          statusModalVisibility: true,
        },
        () => {
          setTimeout(this.onVerifyStatusModalClose, 1000);
        },
      );
    }

    if (
      this.props.preferences.isSaving &&
      !nextProps.preferences.isSaving &&
      nextProps.preferences.saveError
    ) {
      this.setState({
        isSaving: false,
        saveError:
          nextProps.preferences.saveError ||
          'An error occurred while saving preferences',
      });
    }

    if (
      this.props.preferences.isFetchingPreferences &&
      !nextProps.preferences.isFetchingPreferences
    ) {
      const newPreferences = decodeData(nextProps.preferences.details);
      this.setState({
        preferences: Object.assign({}, this.state.preferences, newPreferences),
      });
    }
  }

  openAccordion = (index) => {
    if (index !== this.state.accordion) {
      this.setState({
        accordion: index,
      });
    } else {
      this.setState({
        accordion: -1,
      });
    }
  };

  onVerifyStatusModalClose() {
    this.setState({
      statusModalVisibility: false,
    });
  }

  onPreferencesFormSubmit(originalPreferences, currentValues, actionIndex) {
    const preferences = JSON.parse(
      JSON.stringify(currentValues || this.state.preferences),
    );
    this.setState({ saveError: null });

    /* Sanitize data */
    if (
      preferences.business_contact_numbers &&
      preferences.business_contact_numbers.length
    ) {
      const sanitizedContactNumbers = [];
      for (
        let i = 0, l = preferences.business_contact_numbers.length;
        i < l;
        i += 1
      ) {
        if (preferences.business_contact_numbers[i]) {
          sanitizedContactNumbers.push(preferences.business_contact_numbers[i]);
        }
      }
      preferences.business_contact_numbers = sanitizedContactNumbers;
    }

    const trimStringFields = (obj) => {
      if (!obj || typeof obj !== 'object') return obj;

      const result = Array.isArray(obj) ? [] : {};

      Object.keys(obj).forEach((key) => {
        if (typeof obj[key] === 'string') {
          result[key] = obj[key].trim();
        } else if (obj[key] && typeof obj[key] === 'object') {
          result[key] = trimStringFields(obj[key]);
        } else {
          result[key] = obj[key];
        }
      });
      return result;
    };

    const trimmedPreferences = trimStringFields(preferences);

    const validationErrors = validate(
      trimmedPreferences,
      actionIndex,
      this.props?.preferences,
    );

    if (Object.keys(validationErrors).length) {
      this.setState(
        {
          errors: validationErrors,
          isSaving: false,
        },
        () => {
          const firstErrorKey = Object.keys(this.state.errors)[0];
          if (
            firstErrorKey !== 'pricing_info' &&
            firstErrorKey !== 'first_message'
          ) {
            if (this.formRefs[firstErrorKey]) {
              this.formRefs[firstErrorKey].scrollIntoView();
            }
          }
        },
      );
    } else {
      const newPreferences = encodeData(
        this.props.preferences.details,
        trimmedPreferences,
      );
      this.setState(
        {
          errors: validationErrors,
          isSaving: true,
        },
        () => {
          this.props.setPreferences({ preferences: newPreferences });
        },
      );
    }
  }

  setRef(target, refName) {
    if (!target) return;

    if (refName) {
      this.formRefs[refName] = target;
    } else {
      this.formRefs[target.name] = target;
    }
  }

  HandleNotificationSetting(event) {
    const target = event.target;
    const name = target.name;
    const value = target.value;
    const current_state = [...this.state.preferences.receive_immediately];
    if (current_state.includes(value)) {
      current_state.splice(current_state.indexOf(value), 1);
    } else {
      current_state.push(value);
    }
    const preferences = Object.assign({}, this.state.preferences, {
      [name]: current_state,
    });

    const errors = Object.assign({}, this.state.errors, {
      [event.target.fieldName
        ? `${name}.${event.target.fieldName}`
        : name]: null,
    });

    this.setState({ preferences, errors });
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    if (
      (name === 'average_booking_value' && value.length < 6) ||
      name !== 'average_booking_value'
    ) {
      if (
        (typeof value === 'string' &&
          (value === '' || value?.trim().length > 0)) ||
        typeof value !== 'string'
      ) {
        const arrayvalus = ['notification_email', 'notification_phone'];
        const isArrayValue = arrayvalus.includes(name);
        const preferences = Object.assign({}, this.state.preferences, {
          ...(isArrayValue && { [name]: [value] }),
          ...(!isArrayValue && { [name]: value }),
        });

        const errors = Object.assign({}, this.state.errors, {
          [event.target.fieldName
            ? `${name}.${event.target.fieldName}`
            : name]: null,
        });

        this.setState({ preferences, errors });
      }
    }
  }

  handleInputBlur(event) {
    const preferences = Object.assign({}, this.state.preferences);
    if (
      event.target.name === 'business_contact_numbers.0' &&
      !preferences.billing_contact_details.phone_number
    ) {
      preferences.billing_contact_details = Object.assign(
        {},
        preferences.billing_contact_details,
        {
          phone_number: event.target.value,
        },
      );

      this.setState({ preferences });
    }
  }

  handleCustomPreferenceAdd(preference) {
    const preferences = Object.assign({}, this.state.preferences);

    const uuid = utils.generateUUID();
    const customRequests = Object.assign({}, preferences.custom_requests, {
      [uuid]: preference,
    });

    preferences.custom_requests = customRequests;

    this.setState(
      {
        preferences,
      },
      () => {
        this.onPreferencesFormSubmit();
      },
    );
  }

  onCancelClick = () => {
    const newPreferences = decodeData(this.props.preferences.details);
    this.setState({
      preferences: Object.assign({}, this.state.preferences, newPreferences),
      loading: false,
      errors: {},
      saveError: null,
      accordion: -1,
    });
  };

  ifMissedCallDisabled = (isSaving) => {
    if (isSaving) {
      return true;
    }
    return false;
  };

  isSectionNotEmpty = (object, values) => {
    if (object) {
      const couponProperties = [
        'can_voucher_be_combined_with_offer',
        'collect_coupon_number',
        'is_expired_voucher_accepted',
      ];

      for (let i = 0; i < values.length; i++) {
        if (values[i] === 'cc_not_on_file_action') {
          if (
            object.hasOwnProperty(values[i]) &&
            object.hasOwnProperty('collect_credit_card')
          ) {
            return true;
          }
        } else if (couponProperties.includes(values[i])) {
          if (
            object.hasOwnProperty(values[i]) &&
            object.hasOwnProperty('discount_coupons')
          ) {
            return true;
          }
        } else if (object.hasOwnProperty(values[i])) {
          return true;
        }
      }
    }

    return false;
  };

  handleHiddenPreferencesChange = (event) => {
    const { name, value, type, checked } = event.target;

    const updatedPreferences = JSON.parse(
      JSON.stringify(this.state.preferences),
    );

    if (type === 'checkbox') {
      updatedPreferences[name] = checked;
    } else if (name === 'appointment_preferences') {
      if (!updatedPreferences.appointment_preferences) {
        updatedPreferences.appointment_preferences = {};
      }
      updatedPreferences.appointment_preferences = {
        ...updatedPreferences.appointment_preferences,
        ...value,
      };
    } else if (name === 'cancellation_details') {
      if (!updatedPreferences.cancellation_details) {
        updatedPreferences.cancellation_details = {};
      }
      updatedPreferences.cancellation_details = {
        ...updatedPreferences.cancellation_details,
        ...value,
      };
    } else if (name === 'client_notification_preferences') {
      if (!updatedPreferences.client_notification_preferences) {
        updatedPreferences.client_notification_preferences = {};
      }
      updatedPreferences.client_notification_preferences = {
        ...updatedPreferences.client_notification_preferences,
        ...value,
      };
    } else if (
      typeof value === 'object' &&
      value !== null &&
      !Array.isArray(value)
    ) {
      if (!updatedPreferences[name]) {
        updatedPreferences[name] = {};
      }
      updatedPreferences[name] = { ...updatedPreferences[name], ...value };
    } else {
      updatedPreferences[name] = value;
    }

    this.setState({
      preferences: updatedPreferences,
    });
  };

  handleHiddenPreferencesErrorChange = (fieldName, error) => {
    this.setState(prevState => ({
      errors: {
        ...prevState.errors,
        [fieldName]: error
      }
    }));
  };

  render() {
    let Notifications = WellnessNotifications;
    let Bookings = WellnessBookings;
    let Chats = WellnessChats;
    let ClientBilling = WellnessClientBilling;
    let BusinessProfile = WellnessBusinessProfile;
    let Classes;
    let Memberships;
    const { preferences, currentDomain, auth, softwares } = this.props;
    const { isMytime, statusModalVisibility } = this.state;
    const csroles = ['CS_ADMIN', 'CS_SETUP', 'CS_SALES'];
    const isCSLogin = csroles.includes(auth.role);
    const features = utils.getCookie('features');
    if (currentDomain === DENTAL) {
      Notifications = DentalNotifications;
      Bookings = DentalBookings;
      Chats = DentalChats;
      ClientBilling = DentalClientBilling;
      BusinessProfile = DentalBusinessProfile;
    }

    if (currentDomain === FITNESS) {
      Classes = FitnessClasses;
      Memberships = FitnessMemberships;
      Chats = FitnessChats;
    }

    return (
      <div className="preferences">
        {preferences?.isFetchingPreferences ? (
          <div className="common-loader">
            <Loading />
          </div>
        ) : (
          <>
            <div className="card">
              <div className="card__content">
                <form
                  className="preferences__content"
                  onSubmit={(e) => {
                    e.preventDefault();
                  }}
                  noValidate
                >
                  {/* Mandatory */}
                  <div
                    className="customization-list"
                    onClick={() => this.openAccordion('0')}
                  >
                    <div className="tabs">
                      <div
                        className={classnames('title', {
                          'selected-accordion': this.state.accordion == 0,
                        })}
                      >
                        General Information
                      </div>
                    </div>
                    <div
                      className={classnames('acrdn-btn', {
                        'selected-accordion': this.state.accordion == 0,
                      })}
                    >
                      <i className="material-icons">keyboard_arrow_down</i>
                    </div>
                  </div>
                  {preferences.details && this.state.accordion == 0 ? (
                    <div className="preferences__content__row">
                      <div
                        className="preferences__content__row__data"
                        ref="acc0"
                      >
                        <WellnessMandatory
                          details={this.state.preferences}
                          onBlur={this.handleInputBlur}
                          onChange={this.handleInputChange}
                          errors={this.state.errors}
                          setRef={this.setRef}
                          preferences={preferences}
                          softwares={this.props.softwares}
                        />
                        <BusinessProfile
                          details={this.state.preferences}
                          onBlur={this.handleInputBlur}
                          onChange={this.handleInputChange}
                          errors={this.state.errors}
                          setRef={this.setRef}
                          preferences={preferences}
                          disabled={
                            !isMandatoryComplete(this.state.preferences)
                          }
                        />
                        <Actions
                          disabled={
                            this.state.isSaving ||
                            !isMandatoryComplete(this.state.preferences)
                          }
                          preferences={this.props.preferences.details}
                          values={this.state.preferences}
                          onPreferencesFormSubmit={this.onPreferencesFormSubmit}
                          isSaving={this.state.isSaving}
                          saveError={this.state.saveError}
                          onCancelClick={this.onCancelClick}
                          actionIndex={0}
                        />
                      </div>
                    </div>
                  ) : (
                    undefined
                  )}

                  {/* Voice Greeting */}
                  <div
                    className="customization-list"
                    onClick={() => this.openAccordion('1')}
                  >
                    <div className="tabs">
                      <div
                        className={classnames('title', {
                          'selected-accordion': this.state.accordion == 1,
                        })}
                      >
                        Missed Calls
                      </div>
                    </div>
                    <div
                      className={classnames('acrdn-btn', {
                        'selected-accordion': this.state.accordion == 1,
                      })}
                    >
                      <i className="material-icons">keyboard_arrow_down</i>
                    </div>
                  </div>
                  {preferences.details && this.state.accordion == 1 ? (
                    <div className="preferences__content__row">
                      <div className="preferences__content__row__data">
                          {Array.isArray(features) && !features.includes('VOICE_GREETINGS_HIDDEN') &&
                            <AddVoiceGreeting {...this.props} />
                          }
                        <Chats
                          details={this.state.preferences}
                          onChange={this.handleInputChange}
                          errors={this.state.errors}
                          setRef={this.setRef}
                          preferences={preferences}
                          disabled={
                            !isMandatoryComplete(this.state.preferences)
                          }
                          softwares={this.props.softwares}
                        />
                        <Actions
                          disabled={this.ifMissedCallDisabled(
                            this.state.isSaving,
                          )}
                          preferences={this.props.preferences.details}
                          values={this.state.preferences}
                          onPreferencesFormSubmit={this.onPreferencesFormSubmit}
                          isSaving={this.state.isSaving}
                          saveError={this.state.saveError}
                          onCancelClick={this.onCancelClick}
                          actionIndex={1}
                        />
                      </div>
                    </div>
                  ) : (
                    undefined
                  )}

                  {/* Notifications */}
                  <div
                    className="customization-list"
                    onClick={() => this.openAccordion('2')}
                  >
                    <div className="tabs">
                      <div
                        className={classnames('title', {
                          'selected-accordion': this.state.accordion == 2,
                        })}
                      >
                        Notifications
                      </div>
                    </div>
                    <div
                      className={classnames('acrdn-btn', {
                        'selected-accordion': this.state.accordion == 2,
                      })}
                    >
                      <i className="material-icons">keyboard_arrow_down</i>
                    </div>
                  </div>
                  {preferences.details && this.state.accordion == 2 ? (
                    <div className="preferences__content__row">
                      <div className="preferences__content__row__data">
                        <Notifications
                          details={this.state.preferences}
                          onChange={this.handleInputChange}
                          intentChange={this.HandleNotificationSetting}
                          errors={this.state.errors}
                          setRef={this.setRef}
                          disabled={
                            !isMandatoryComplete(this.state.preferences)
                          }
                          intents={this.props.preferences.intents}
                          preferences={preferences}
                          auth={this.props.auth}
                          softwares={this.props.softwares}
                        />
                        <Actions
                          disabled={
                            this.state.isSaving ||
                            !isMandatoryComplete(this.state.preferences)
                          }
                          preferences={this.props.preferences.details}
                          values={this.state.preferences}
                          onPreferencesFormSubmit={this.onPreferencesFormSubmit}
                          isSaving={this.state.isSaving}
                          saveError={this.state.saveError}
                          onCancelClick={this.onCancelClick}
                          actionIndex={2}
                        />
                      </div>
                    </div>
                  ) : (
                    undefined
                  )}

                  {/* Bookings */}
                  <div
                    className="customization-list"
                    onClick={() => this.openAccordion('3')}
                  >
                    <div className="tabs">
                      <div
                        className={classnames('title', {
                          'selected-accordion': this.state.accordion == 3,
                        })}
                      >
                        Appointments
                      </div>
                    </div>
                    <div
                      className={classnames('acrdn-btn', {
                        'selected-accordion': this.state.accordion == 3,
                      })}
                    >
                      <i className="material-icons">keyboard_arrow_down</i>
                    </div>
                  </div>
                  {preferences.details && this.state.accordion == 3 ? (
                    <div className="preferences__content__row">
                      <div className="preferences__content__row__data">
                        <Bookings
                          details={this.state.preferences}
                          onChange={this.handleInputChange}
                          errors={this.state.errors}
                          setRef={this.setRef}
                          disabled={
                            !isMandatoryComplete(this.state.preferences)
                          }
                          auth={this.props.auth}
                          preferences={preferences}
                          softwares={this.props.softwares}
                        />
                        <Actions
                          disabled={
                            this.state.isSaving ||
                            !isMandatoryComplete(this.state.preferences)
                          }
                          preferences={this.props.preferences.details}
                          values={this.state.preferences}
                          onPreferencesFormSubmit={this.onPreferencesFormSubmit}
                          isSaving={this.state.isSaving}
                          saveError={this.state.saveError}
                          onCancelClick={this.onCancelClick}
                          actionIndex={3}
                        />
                      </div>
                    </div>
                  ) : (
                    undefined
                  )}

                  {/* Classes */}
                  {Classes ? (
                    <>
                      <div
                        className="customization-list"
                        onClick={() => this.openAccordion('4')}
                      >
                        <div className="tabs">
                          <div
                            className={classnames('title', {
                              'selected-accordion': this.state.accordion == 4,
                            })}
                          >
                            Classes
                          </div>
                        </div>
                        <div
                          className={classnames('acrdn-btn', {
                            'selected-accordion': this.state.accordion == 4,
                          })}
                        >
                          <i className="material-icons">keyboard_arrow_down</i>
                        </div>
                      </div>
                      {this.props.preferences.details &&
                      this.state.accordion == 4 ? (
                        <div className="preferences__content__row">
                          <div className="preferences__content__row__data">
                            <FitnessClasses
                              details={this.state.preferences}
                              bookingSW={this.state.bookingSW}
                              classes={this.props.preferences.classes}
                              onChange={this.handleInputChange}
                              errors={this.state.errors}
                              preferences={preferences}
                              disabled={
                                !isMandatoryComplete(this.state.preferences)
                              }
                            />
                            <Actions
                              disabled={
                                this.state.isSaving ||
                                !isMandatoryComplete(this.state.preferences)
                              }
                              preferences={this.props.preferences.details}
                              values={this.state.preferences}
                              onPreferencesFormSubmit={
                                this.onPreferencesFormSubmit
                              }
                              isSaving={this.state.isSaving}
                              saveError={this.state.saveError}
                              onCancelClick={this.onCancelClick}
                              actionIndex={4}
                            />
                          </div>
                        </div>
                      ) : (
                        undefined
                      )}
                    </>
                  ) : (
                    undefined
                  )}

                  {/* Memberships */}
                  {Memberships ? (
                    <>
                      <div
                        className="customization-list"
                        onClick={() => this.openAccordion('5')}
                      >
                        <div className="tabs">
                          <div
                            className={classnames('title', {
                              'selected-accordion': this.state.accordion == 5,
                            })}
                          >
                            Memberships
                          </div>
                        </div>
                        <div
                          className={classnames('acrdn-btn', {
                            'selected-accordion': this.state.accordion == 5,
                          })}
                        >
                          <i className="material-icons">keyboard_arrow_down</i>
                        </div>
                      </div>
                      {this.props.preferences.details &&
                      this.state.accordion == 5 ? (
                        <div className="preferences__content__row">
                          <div className="preferences__content__row__data">
                            <FitnessMemberships
                              details={this.state.preferences}
                              onChange={this.handleInputChange}
                              errors={this.state.errors}
                              preferences={preferences}
                              disabled={
                                !isMandatoryComplete(this.state.preferences)
                              }
                            />
                            <Actions
                              disabled={
                                this.state.isSaving ||
                                !isMandatoryComplete(this.state.preferences)
                              }
                              preferences={this.props.preferences.details}
                              values={this.state.preferences}
                              onPreferencesFormSubmit={
                                this.onPreferencesFormSubmit
                              }
                              isSaving={this.state.isSaving}
                              saveError={this.state.saveError}
                              onCancelClick={this.onCancelClick}
                              actionIndex={5}
                            />
                          </div>
                        </div>
                      ) : (
                        undefined
                      )}
                    </>
                  ) : (
                    undefined
                  )}

                  {/* Client Billing */}
                  {softwares?.is_truelark && this.isSectionNotEmpty(
                    preferences?.schema?.appointment_preferences?.properties,
                    [
                      'collect_credit_card',
                      'cc_not_on_file_action',
                      'discount_coupons',
                      'collect_coupon_number',
                      'is_expired_voucher_accepted',
                      'can_voucher_be_combined_with_offer',
                      'cc_for_coupons',
                      'accepted_insurance_policies',
                    ],
                  ) && (
                    <div
                      className="customization-list"
                      onClick={() => this.openAccordion('6')}
                    >
                      <div className="tabs">
                        <div
                          className={classnames('title', {
                            'selected-accordion': this.state.accordion == 6,
                          })}
                        >
                          Client Billing
                        </div>
                      </div>
                      <div
                        className={classnames('acrdn-btn', {
                          'selected-accordion': this.state.accordion == 6,
                        })}
                      >
                        <i className="material-icons">keyboard_arrow_down</i>
                      </div>
                    </div>
                  )}
                  {this.props.preferences.details &&
                  this.state.accordion == 6 ? (
                    <div className="preferences__content__row">
                      <div className="preferences__content__row__data">
                        <ClientBilling
                          isMytime={isMytime}
                          details={this.state.preferences}
                          onChange={this.handleInputChange}
                          errors={this.state.errors}
                          auth={this.props.auth}
                          softwares={this.props.softwares}
                          preferences={preferences}
                          disabled={
                            !isMandatoryComplete(this.state.preferences)
                          }
                        />
                        <Actions
                          disabled={
                            this.state.isSaving ||
                            !isMandatoryComplete(this.state.preferences)
                          }
                          preferences={this.props.preferences.details}
                          values={this.state.preferences}
                          onPreferencesFormSubmit={this.onPreferencesFormSubmit}
                          isSaving={this.state.isSaving}
                          saveError={this.state.saveError}
                          onCancelClick={this.onCancelClick}
                          actionIndex={6}
                        />
                      </div>
                    </div>
                  ) : (
                    undefined
                  )}

                    {/* Advanced */}
                    {Array.isArray(features) && !features.includes('CONTACT_INFO_HIDDEN') &&
                      <div
                        className="customization-list"
                        onClick={() => this.openAccordion('7')}
                      >
                        <div className="tabs">
                          <div
                            className={classnames('title', {
                              'selected-accordion': this.state.accordion == 7,
                            })}
                          >
                            Advanced
                          </div>
                        </div>
                        <div
                          className={classnames('acrdn-btn', {
                            'selected-accordion': this.state.accordion == 7,
                          })}
                        >
                          <i className="material-icons">keyboard_arrow_down</i>
                        </div>
                      </div>}
                  {this.props.preferences.details &&
                  this.state.accordion == 7 ? (
                    <div className="preferences__content__row">
                      <div className="preferences__content__row__data">
                        <WellnessAdvanced
                          details={this.state.preferences}
                          onChange={this.handleInputChange}
                          onRequestAdd={this.handleCustomPreferenceAdd}
                          errors={this.state.errors}
                          preferences={preferences}
                          disabled={
                            !isMandatoryComplete(this.state.preferences)
                          }
                        />
                      </div>
                    </div>
                  ) : (
                    undefined
                  )}

                  {/* Hidden Preferences */}
                  {isCSLogin && (
                    <>
                      <div
                        className="customization-list"
                        onClick={() => this.openAccordion('8')}
                      >
                        <div className="tabs">
                          <div
                            className={classnames('title', {
                              'selected-accordion': this.state.accordion == 8,
                            })}
                          >
                            Hidden Preferences
                          </div>
                        </div>
                        <div
                          className={classnames('acrdn-btn', {
                            'selected-accordion': this.state.accordion == 8,
                          })}
                        >
                          <i className="material-icons">keyboard_arrow_down</i>
                        </div>
                      </div>
                      {preferences.details && this.state.accordion == 8 ? (
                        <div className="preferences__content__row">
                          <div className="preferences__content__row__data">
                            <HiddenPreferences
                              details={this.state.preferences}
                              onChange={this.handleHiddenPreferencesChange}
                              onErrorChange={this.handleHiddenPreferencesErrorChange}
                              errors={this.state.errors}
                              setRef={this.setRef}
                              disabled={
                                !isMandatoryComplete(this.state.preferences) ||
                                this.state.isSaving
                              }
                              auth={this.props.auth}
                              preferences={preferences}
                              business={this.props.business}
                            />
                            <Actions
                              disabled={
                                this.state.isSaving ||
                                !isMandatoryComplete(this.state.preferences)
                              }
                              preferences={this.props.preferences.details}
                              values={this.state.preferences}
                              onPreferencesFormSubmit={
                                this.onPreferencesFormSubmit
                              }
                              isSaving={this.state.isSaving}
                              saveError={this.state.saveError}
                              onCancelClick={this.onCancelClick}
                              actionIndex={8}
                            />
                          </div>
                        </div>
                      ) : (
                        undefined
                      )}
                    </>
                  )}
                </form>

                {typeof this.props.preferences.isPreferenceSaved ===
                  'boolean' && statusModalVisibility ? (
                  <StatusModal
                    visibility={this.state.statusModalVisibility}
                    status={this.props.preferences.isPreferenceSaved}
                    onClose={this.onVerifyStatusModalClose}
                  />
                ) : (
                  undefined
                )}
              </div>
            </div>

            <div className="footer-container">
              <Footnote />
            </div>
          </>
        )}
      </div>
    );
  }
}

Preferences.defaultProps = {
  currentDomain: '',
  getPreferences: () => {},
  setPreferences: () => {},
  getFreePricingPlans: () => {},
  getBusinessDetails: () => {},
  business: {},
};

Preferences.propTypes = {
  currentDomain: PropTypes.string,
  getPreferences: PropTypes.func,
  setPreferences: PropTypes.func,
  getBusinessDetails: PropTypes.func,
  getFreePricingPlans: PropTypes.func,
  business: PropTypes.shape({
    id: PropTypes.string,
    info: PropTypes.object,
    selectedLocation: PropTypes.object,
    businessDetailsFetched: PropTypes.bool,
    locations: PropTypes.arrayOf(PropTypes.shape({
      studioId: PropTypes.string,
      studioName: PropTypes.string,
      locationName: PropTypes.string,
      city: PropTypes.string,
      state: PropTypes.string,
      disabled: PropTypes.bool,
    })),
    details: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      locations: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string,
        display_text: PropTypes.string,
        city: PropTypes.string,
        state: PropTypes.string,
        disabled: PropTypes.bool,
      })),
      staffs: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string,
        first_name: PropTypes.string,
        last_name: PropTypes.string,
      })),
      services: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string,
        display_name: PropTypes.string,
      })),
      resources: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string,
        display_name: PropTypes.string,
      })),
    }),
    data: PropTypes.shape({
      staffs: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string,
        first_name: PropTypes.string,
        last_name: PropTypes.string,
      })),
      services: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string,
        display_name: PropTypes.string,
      })),
      resources: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string,
        display_name: PropTypes.string,
      })),
    }),
    staffs: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string,
      first_name: PropTypes.string,
      last_name: PropTypes.string,
      staff_type: PropTypes.string,
    })),
    services: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string,
      display_name: PropTypes.string,
      business_id: PropTypes.string,
      capacity: PropTypes.number,
      staff_required: PropTypes.number,
      cost: PropTypes.number,
    })),
    resources: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string,
      display_name: PropTypes.string,
      business_id: PropTypes.string,
    })),
  }),
  preferences: PropTypes.shape({
    isFetchingPreferences: PropTypes.bool,
    isPreferenceSaved: PropTypes.bool,
    isSaving: PropTypes.bool,
    saveError: PropTypes.string,
    details: PropTypes.shape(),
    classes: PropTypes.shape(),
    dental: PropTypes.shape(),
  }).isRequired,
  softwares: PropTypes.shape().isRequired,
  auth: PropTypes.shape().isRequired,
};